// extracted by mini-css-extract-plugin
export var standaloneTable = "_fo-0";
export var standaloneTableWithBodyFill = "_fo-1";
export var withExtraHeader = "_fo-2";